import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import queryString from "qs";
import { AdjustedApplicationRentActivity } from "shared/app/ActivityLog/types";
import { activityLogsQueryKey } from "shared/queries/useActivityLogsController";

interface Props {
  applicationId?: number;
}

// It's separated to keep facade-like structure. Also may need some FE processing in future
export const useApplicationRentActivityLogsController = ({
  applicationId
}: Props) =>
  useQuery<AdjustedApplicationRentActivity[]>({
    queryKey: activityLogsQueryKey(applicationId ?? 0),
    queryFn: () => {
      const params = {
        events: [
          "application_rent_adjusted",
          "application_rent_automatically_adjusted"
        ]
      };
      const url =
        `portal/v1/applications/${applicationId}/activity_logs?` +
        queryString.stringify(params, { arrayFormat: "brackets" });
      return instance.get(url).then(({ data }) => data.activity_logs);
    },
    enabled: Boolean(applicationId)
  });
